import React, { useCallback, useContext, useState } from 'react';
import { style } from 'typestyle';
import { useTranslation } from 'react-i18next';
import { registerAdmin } from './registration.service';
import * as styles from './registration.styles';
import AppConstants from '../../../core/app.constants';
import PrimaryButton from '../../../core/components/buttons/primary-button.component';
import Column from '../../../core/components/column/column.component';
import { MainAxisAlignment, CrossAxisAlignment } from '../../../core/components/flex/flex.component';
import notify from '../../../core/components/notify/notify.component';
import Row from '../../../core/components/row/row.component';
import { IsMobileContext } from '../../../core/context/is-mobile';
import stringIsNullOrWhitespace from '../../../core/utils/validation-utils';
import Input from '../../../core/components/input/input.component';
import { useKeycloak } from '../keycloak/KeycloakProvider';

const Register = (): React.JSX.Element => {
  const isMobile = useContext(IsMobileContext);
  const { t } = useTranslation();
  const keycloak = useKeycloak();
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<string>(AppConstants.ADMIN_ROLE);

  const saveRegistration = useCallback(async (): Promise<void> => {
    if (stringIsNullOrWhitespace(email)) {
      notify(t('email-empty-message'), false);
    } else {
      setIsLoading(true);
      const response = await registerAdmin({ email, role }, keycloak);
      if (response.success) {
        notify(t('user-registration-success-message'), true);
        setRole(AppConstants.ADMIN_ROLE);
        setEmail('');
      } else {
        notify(response.errorMessage ?? t('registration-error-message'), false);
      }
      setIsLoading(false);
    }
  }, [email, role, keycloak, t]);

  return (
    <div className={style(styles.registerBackground)}>
      <Row mainAxisAlignment={MainAxisAlignment.End}>
        <div className={style(styles.card(isMobile))}>
          <Column crossAxisAlignment={CrossAxisAlignment.Stretch}>
            <span className={style(styles.columnHeader)}>{t('register').toUpperCase()}</span>
            <Input
              placeholder={t('email').toLowerCase()}
              value={email}
              onChange={setEmail}
              onEnter={(): void => {
                saveRegistration();
              }}
            />
            <select
              className={style(styles.dropDown)}
              value={role}
              onChange={(e): void => {
                setRole(e.target.value);
              }}
              onBlur={(e): void => {
                setRole(e.target.value);
              }}
            >
              <option value={AppConstants.ADMIN_ROLE}>{t('administrator')}</option>
              <option value={AppConstants.WHYELLOW_ROLE}>{t('whyellow')}</option>
            </select>
            <div className={style(styles.button)}>
              <PrimaryButton
                loading={isLoading}
                fullWidth
                onClick={(): void => {
                  saveRegistration();
                }}
              >
                {t('register')}
              </PrimaryButton>
            </div>
          </Column>
        </div>
      </Row>
    </div>
  );
};

export default Register;
